<template>
    <div class="bm-header">

        <div class="title-container" :style="$store.state.isCollapse==true?'width:50px;font-size:10px':''" >
             <h2 style="color: #124B8B">报名管理系统</h2>
        </div>
      <div style="flex: 1; font-size: 20px" >
        <span :class="$store.state.isCollapse==true?'el-icon-s-unfold':'el-icon-s-fold'" style="cursor: pointer" @click="handleMenu"></span>
      </div>
      <div class="flex dis-flex content-container">
            <el-popover
                    placement="bottom"
                    width="100"
                    trigger="hover">
                <label slot="reference">{{userInfo?userInfo.username:'---'}}</label>
                <div style="display: flex;flex-direction: column">
                    <el-button type="text" @click="handleChangeBaseInfo">基本信息</el-button>
                    <el-button type="text" @click="handleChangePassword">修改密码</el-button>
                    <el-button type="text" @click="handleLogout">退出</el-button>
                </div>
            </el-popover>

        </div>

        <EditPasswordDialog ref="EditPasswordDialog"/>
        <EditInfoDialog ref="EditInfoDialog"></EditInfoDialog>
    </div>
</template>

<script>
    import EditPasswordDialog from "./EditPasswordDialog";
    import EditInfoDialog from "./EditInfoDialog";
    export default {
        components: {EditPasswordDialog,EditInfoDialog},
        name: "MHeader",
        data() {
            return {
              collapse:true
            }
        },
      computed: {
        isCollapse() {
          return this.$store.state.isCollapse;
        },
      },
        methods: {
          handleMenu() {
            console.log('this.$store.state',this.$store.state.isCollapse)
            this.$store.commit("collapseMenu",this.$store.state.isCollapse)
          },
          // collapseFun(){
          //   // console.log('123',this.isCollapse)
          //   // this.isCollapse = !this.isCollapse
          //   // this.SETCOLLAPSE(this.collapse)
          //   // this.$store.dispatch("setCollapse", this.isCollapse)
          //   // this.$store.commit('SETCOLLAPSE', this.collapse)
          // },
            handleChangeBaseInfo() {
                this.$refs.EditInfoDialog && this.$refs.EditInfoDialog.setMaskVisible(true, {});
            },

            handleChangePassword() {
                this.$refs.EditPasswordDialog && this.$refs.EditPasswordDialog.setMaskVisible(true, {});
            },

            // 登出
            handleLogout() {
                axios.post(Urls.URL.logout).then(res => {
                    if(res.status == '200') {
                        this.$store.dispatch("setToken", null)
                        this.$store.dispatch("setUserInfo", null)
                        this.$router.push({name: 'Login'})
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
    .bm-header {
        display: -ms-flex;
        display: flex;
        align-items: center;
        box-sizing border-box
        font-size: 14px;
        letter-spacing: 1px;
        color: #868686;
        background-color: #fff;
        justify-content space-between
        .title-container {
            height 60px;
            width: 199px;
            border-right 1px solid #EDEFF2
            background-color: #FFFFFF;
            text-align center
            display flex
            justify-content center
            align-items center
            img {
                width 103px
                height 37px;
            }
        }

        .content-container {
            width 120px
            height 100%;
            display flex
            align-items center;
            justify-content: flex-end;
        }
    }

    .dis-flex {
        margin-right 5%
    }

    /deep/.el-button+.el-button {
        margin-left 0
    }
</style>
